import React from "react";
import { store } from '../../store'
import connectWithStore from '../../utils/store'

import { makeContractsByKennitala, formatKennitala, checkIfActiveContractForKennitala, getDescriptiveContractName } from '../../utils'

import { CONTRACTS_VISIBLE_MAPPING } from '../../constants'
import DetailedContractInfo from "../detailed-contract-info";

import moment from 'moment';
import CardForm from "../card-form";
import ContractInfo from "../contract-info";

class MyPagesCreditCard extends React.Component {
    constructor(props) {
        super(props)
    }
    render () {

        if (this.props.customerPayers.customerList && this.props.customerPayers.customerList.length > 0) {

            let customer = this.props.customerPayers.customerList.filter(c => c.Customer.AccountNum === this.props.customerId)
            let creditCard = []
            if(customer.length > 0 && customer[0].Customer.CreditCards) {
                creditCard = customer[0].Customer.CreditCards.filter(c => c.DefaultCard === 1)
            }


            return(
                <>
                    <div className="edit-creditcard">
                        { customer.length > 0 && creditCard && creditCard.length > 0 &&
                            <div className="form-row">
                                <div className="col-sm-4"><label htmlFor="" className="">Skráð greiðslukort hjá Allianz</label></div>
                                <div className="col-sm-8 text-left">
                                    {creditCard[0].CardNumber || creditCard[0].CardNumer}
                                </div>
                            </div>
                        }
                        {/* <i>Sem stendur er ekki hægt að breyta korti. Við biðjumst velvirðingar á þeim óþægindum sem þetta kann að valda.</i> */}
                        <div className="form-row">
                            <div className="col-sm-4"><label htmlFor="" className="">{ creditCard.length > 0 ? 'Breyta greiðslukorti á skrá' : 'Bæta við greiðslukorti' }</label></div>
                            <div className="col-sm-8 text-left">
                                <CardForm className="xs-mb-40 card-form col-12 p-0" virtualCard={this.props.virtualCard} payerId={this.props.customerId} dispatch={this.props.dispatch} payers={this.props.payers} shouldAutoSave={true} inMyPages={true} />
                            </div>
                        </div>
                    </div>

                    <h3>Þú ert skráð/ur sem greiðandi að eftirfarandi tryggingum:</h3>
                    <p>Vakin er athygli á því að ef að iðgjöld eru ógreidd verða öll iðgjöld innheimt í næstu skuldfærslu.<br />Ef það hentar ekki vinsamlegast hafið samband við skrifstofu Allianz.</p>

                    {this.props.customerPayers.customerList.map((customer, key) => {
                        let allContracts =
                        <div key={key} className="my-pages-container" id="accordion">
                                {Object.entries(makeContractsByKennitala(customer.Contracts)).filter(key => !key.includes("Name")).map(([key, value]) => {
                                    
                                    
                                    if (checkIfActiveContractForKennitala(value)) {
                                        
                                        return (
                                            <React.Fragment key={key}>
                                                {Object.values(value).map((contract) => {
                                                    return contract.map( (c ,key) => {
                                                        if (!['VID', 'VIDE'].includes(c.ContractType) && CONTRACTS_VISIBLE_MAPPING[c.ContractType] && CONTRACTS_VISIBLE_MAPPING[c.ContractType][c.ContractStatusId] !== undefined) {
                                                            return (<div key={key} className="customer-container">
                                                                <div className="customer">{getDescriptiveContractName(c.ContractType)}</div>
                                                                <div className="xs-mt-20 xs-mb-20">
                                                                    <p>Tryggingataki: {c.InvoiceCustName}</p>
                                                                    <p>Tryggingaþegi: {c.CustName}</p>
                                                                </div>
                                                            </div>)
                                                        }
                                                    })
                                                })}
                                            </React.Fragment>
                                        )
                                    } else { return (<></>)}
                                })}
                            </div>

                            return allContracts
                    })}

                </>
            )
        } else {
            return (<></>)
        }
    }
}


MyPagesCreditCard.defaultProps = {
}

function mapStateToProps(state) {

    var f = {
        virtualCard: {},
        payers: {},
        customerPayers: {},
    }
    f.virtualCard = (state.virtualCard === undefined) ? {} : state.virtualCard
    f.payers = (state.payers === undefined) ? {} : state.payers
    f.customerPayers = (state.customerPayers === undefined) ? {} : state.customerPayers

    return f;
}

export default connectWithStore(store, MyPagesCreditCard, mapStateToProps);
